import React from "react";
import { FirstLook } from "./FirstLook.js";
import { SecondLook } from "./secondLook.js";
export function Main() {
    return (React.createElement("main", { className: "landing-page-main" },
        React.createElement(FirstLook, null),
        React.createElement(SecondLook, null)));
}
